import React, { useState, useRef, useEffect } from 'react';
import { Node, WorkspaceData } from './GraphData'
import ReactMarkdown from 'react-markdown'
import modal from './Modal'
import * as cst from './cst'

interface OverviewWindowProps{
  node? : Node
  modalUp : boolean
  workspaceData: WorkspaceData
  postMod : Function
}

export const OverviewWindow : React.FC<OverviewWindowProps> = ({node, modalUp, workspaceData, postMod}) => {
  if(!node || modalUp || !workspaceData){
    return (<div/>)
  }

  return (
    <div className="overview-window">
      <div className="overview-window-header">
        <a href={`/${workspaceData.url}/${node.id}`} style={{justifyContent:"flex-end"}}>{`Task ${node.id}`}</a>
      </div>
      <div className="overview-window-content">
        <div className="modal-title">{node.title}</div>
        <div className="form-field">
          <label>Title:</label>
          <div className="modal-info-label">{node.title}</div>
        </div>
        <div className="form-field">
          <label>Description:</label>
          <div className="modal-info-label"><ReactMarkdown className="line-break">{node.description}</ReactMarkdown></div>
        </div>
        <div className="form-field">
          <label>Owner:</label>
          <div className="modal-info-label">{node.owner}</div>
        </div>
      </div>
    </div>
  )
}
